import IncrementArrow from './IncrementArrow';

export default IncrementArrow;